import {FC} from 'react'
import {useQueryCDREntitiesRequest} from '../../hooks/useQueryCDRUsersRequest'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type Props = {
  data?: string
}

const CDRDidNumber: FC<Props> = ({data}) => {
  const {state} = useQueryCDREntitiesRequest()

  const line = state.lines.find((u) => u.number === data)

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex justify-content-start flex-column me-3 text-gray-800'>
        <span className='small text-gray-900'>
          {line !== undefined ? (
            <>
              <OverlayTrigger
                delay={{show: 50, hide: 50}}
                overlay={
                  <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                    {data}
                  </Tooltip>
                }
              >
                <span className='text-gray-900 small'>
                  {line.name.length > 27 ? `${line.name.slice(0, 27)}...` : line.name}
                </span>
              </OverlayTrigger>
            </>
          ) : (
            <>{data}</>
          )}
        </span>
      </div>
    </div>
  )
}

export {CDRDidNumber}
